import { ROUTE } from 'constant';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import Shared from 'screens/shared';

export const Repository = ({
  match,
}) => {
  const { id, repoName } = match.params;

  const {
    [ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET]: repo = {},
  } = useSelector((e) => e);

  useEffect(() => {
    actions.containerRegistry.repository.get({ registryId: id, repoName });
  }, [id, repoName]);

  const validTags = repo?.name === repoName ? repo.tags : [];

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.CONTAINER_REGISTRY_REPOSITORY}
      strapIcon="archive"
      strapTitle={repoName}
      isDeleteButton={false}
      isEditButton={false}
    >
      <Shared.widgets.Section
        sectionTitle="Tags"
        isAddButton={false}
        setItemTitle={(name) => name}
        items={validTags}
        className="-m-t-25"
        setItemKey={(e) => e}
        itemIcon="tag"
      />
    </Shared.widgets.Page>
  );
};
